module.exports = __webpack_public_path__ + "img/home.b022cd32.svg";